import Reveal from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "One record, not ten notebooks",
    body: "Boat details, engines, service history, receipts, documents, and photos live together in a single organized place — instead of scattered across paper logs, camera rolls, and email threads.",
  },
  {
    n: "02",
    title: "Nothing slips through",
    body: "A smart maintenance engine matches manufacturer-style intervals to your boat's actual configuration, and local reminders tap you on the shoulder 14 and 7 days before service or expirations come due.",
  },
  {
    n: "03",
    title: "Built for real boats",
    body: "Outboard or inboard, one engine or four, trailer or lift — the maintenance schedule adapts to your setup, and every engine's hours are tracked on their own.",
  },
  {
    n: "04",
    title: "Ready when it matters",
    body: "Generate a polished boat history report for a mechanic, a surveyor, or a buyer — and share a read-only link you can revoke at any time.",
  },
];

export default function Manifesto() {
  return (
    <section className="bg-[#F8FAFC] py-24 sm:py-32" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-[#1D8A99]">
            Why Knot Forgotten?
          </p>
          <h2 className="mt-5 max-w-2xl text-2xl font-bold tracking-tight text-[#0A192F] sm:text-3xl lg:text-4xl">
            A boat asks a lot of its owner.
            <span className="font-serif-display italic text-[#1D8A99]"> The paperwork shouldn't.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-slate-200 bg-slate-200 md:grid-cols-2">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08} className="bg-white">
              <article className="group h-full p-8 transition-colors duration-300 hover:bg-[#E6F4F1]/50 sm:p-10" data-testid={`manifesto-chapter-${c.n}`}>
                <span className="font-serif-display text-5xl font-medium italic text-[#1D8A99]/40 transition-colors duration-300 group-hover:text-[#1D8A99] sm:text-6xl">
                  {c.n}
                </span>
                <h3 className="mt-5 text-xl font-semibold tracking-tight text-[#0A192F] sm:text-2xl">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">{c.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
